import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { memo } from 'react';
import { EnhancedMarkdown } from '../../EnhancedMarkdown';
/**
 * Renders a reasoning message part with expandable details
 */ export const ReasoningPart = /*#__PURE__*/ memo(function ReasoningPart({ part, messageId, index }) {
    return /*#__PURE__*/ _jsxs("details", {
        className: "text-sm text-muted-foreground",
        "data-testid": Testids.assistant.messageReasoning,
        children: [
            /*#__PURE__*/ _jsx("summary", {
                className: "cursor-pointer hover:underline",
                children: "View reasoning"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-2 pl-4 border-l-2 border-muted",
                children: /*#__PURE__*/ _jsx(EnhancedMarkdown, {
                    content: part.text || '',
                    className: "prose-sm"
                })
            })
        ]
    }, `${messageId}-reasoning-${index}`);
});
